module Constants {
    export enum HttpStatusCodes {
        Ok = 200
    }

    export enum HttpReadyStates {
        Uninitialized = 0,
        Loading = 1,
        Loaded = 2,
        Interactive = 3,
        Complete = 4
    }

    export class Impact {
        static outage = "OUTAGE";
        static limited = "LIMITED";
        static ready = "READY";
    }

    export const stateToName = ["Verfügbar", "Wartung", "eingeschränkt verfügbar", "nicht verfügbar"];

    export class HtmlIds {
        static CurrentIncidents: string = "generated_content_current_incidents";
        static LastIncidents: string = "generated_content_last_incidents";
        static PlannedMaintanances: string = "generated_content_planned_maintanances";
        static ActiveMaintanances: string = "generated_content_active_maintanances";
        static DatevAspNotification: string = "generated_content_datevasp";
        static IncidentHistory:string = "generated_content_incident_history";
        static PlannedMaintenanceFilter:string="monthFilterPlanned";
        static CurrentIncidentSearch:string="searchCurrent";
        static IncidentHistorySearch:string="searchHistory";
        static PlannedMaintenanceSearch:string="searchPlanned";
        static AJAXLoaderCurrent:string="ajaxLoaderCurrent";
        static AJAXLoaderPast:string="ajaxLoaderPast";
        static AJAXLoaderFuture:string="ajaxLoaderFuture";
        static ExternalIncidents:string="externalIncidentsDetails";
        static Notifications:string="notifications";
    }

    export class Paths {
        static lastIncidentsJsonPath: string = "https://api.datev-status.de/v1/incidents?lastDays=3";
        static currentIncidentsJsonPath: string = "https://api.datev-status.de/v1/incidents";
        static maintananceJsonPath: string = "https://api.datev-status.de/v1/maintenances";
        static globalmessagesJsonPath:string = "https://api.datev-status.de/v1/globalmessages";
        static externalIncidentsJsonPath:string = "https://api.datev-status.de/v1/incidents-external-systems";
        static servicesTreeJsonPath: string = "https://api.datev-status.de/v1/service-tree-lean";
    }

    export class Refresh {
        static intervallInSeconds: number = 30;
    }

    export class Messages {
        static statusOk = "Alle Anwendungen sind uneingeschränkt verfügbar.";
        static noMaintenance = "Es sind keine Wartungen geplant.";
        static noIncidents = "Keine Störungen aufgetreten.";
        static noFilter = "Alles";
        static noCurrentInSelection = "Ihre Auswahl ergab keine Treffer. Ändern Sie ggf. Ihre Such-Anfrage, um aktuelle Störungen und Wartungen anzuzeigen.";
        static noPastInSelection = "Ihre Auswahl ergab keine Treffer. Ändern Sie ggf. Ihre Such-Anfrage, um behobene Störungen anzuzeigen.";
        static noPlannedInSelection = "Ihre Auswahl ergab keine Treffer. Ändern Sie ggf. Ihre Such-Anfrage oder Filter-Einstellung , um geplante Wartungen anzuzeigen.";
        static noExternalIncidents = "Aktuell liegen keine Informationen über Störungen außerhalb DATEV vor.";
        static errorLoading = "Die Abfrage der Daten ist derzeit leider nicht möglich.";        
    }

    export class DateFormat {
        static jsonFormat: string = "YYYY-MM-DDTHH:mm:ss";
        static daynames: string[] = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];
        static monthnames: string[] = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
        static searchPattern:string = "DD.MM.YYYY HH:mm";
    }
} 

export default Constants;